
<div v-if="relationship">
  Remove {{ relationship.friendlyRelationDisplay }} {{ relationship.inverse_label_title }} from
  <span v-html="inverseModelTitles"></span> model(s)
</div>
